import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var fileListRes;
export const fileListTodo = createAsyncThunk('fileList', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'library/view_file_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "master_folder_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return fileListRes = res.data
    } catch (error) {
        return fileListRes = error.response.data
    }
})


const fileListSlice = createSlice({
    name: 'fileList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(fileListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('fileList', state.data)
            }
        });
        builder.addCase(fileListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default fileListSlice.reducer; 